import http from "./httpService";

const endPoint = "/api/v1/Template";

export function addTemplate(template) {
    return http.post(endPoint, template);
}

export function getAllTemplates() {
    return http.get(endPoint);
}

export function getTemplate(id) {
    return http.get(`${endPoint}/${id}`);
}

export function updateTemplate(id, request) {
    return http.put(`${endPoint}/${id}`, request);
}

export function deleteTemplate(id) {
    return http.delete(`${endPoint}/${id}`);
}

export function applyTemplate(id) {
    return http.post(`${endPoint}/${id}/Apply`);
}

const obj = { 
    addTemplate,
    getAllTemplates,
    getTemplate,
    updateTemplate,
    deleteTemplate,
    applyTemplate
};

export default obj;


// WEBPACK FOOTER //
// ./src/services/templateService.js